import axios from 'axios';

/*
*  This file contains all axios calls related to unlayer email process operations
*/

const BASE_URL = '/app/unlayerEmailFunnel';

export const migrateTemplateToUnlayer = async (design) => {
    const { data } = await axios.post(`${BASE_URL}/template/migrateToUnlayer`, {
        design: JSON.stringify(design),
    });

    return data;
};

export const migrateToUnlayer = async ({
    marketingEmailId,
    name,
    design,
    html,
    funnelId,
}) => {
    const { data } = await axios.post(`${BASE_URL}/migrateToUnlayer/${marketingEmailId}`, {
        design: JSON.stringify(design),
        name,
        funnelId,
        html,
    });

    return data;
};

export const getBardJSON = async (marketingEmailId) => {
    const { data } = await axios.get(`${BASE_URL}/bardTemplate/${marketingEmailId}`);

    return data;
};

export const getUnlayerMigrationPreview = async ({ name, design, funnelId }) => {
    const { data } = await axios.post(`${BASE_URL}/migrateToUnlayerPreview`, {
        design: JSON.stringify(design),
        name,
        funnelId,
    });

    return data;
};

export const getEmailTemplate = async (marketingEmailId) => {
    const { data } = await axios.get(`${BASE_URL}/${marketingEmailId}/emailTemplate`);

    return data;
};

export const getUnlayerEditorConfigForPreview = async () => {
    const { data } = await axios.get(`${BASE_URL}/builderConfigForUnlayerPreview`);

    return data;
};


export const loadCoreConfigs = async (marketingEmailId) => {
    const { data } = await axios.get(`${BASE_URL}/builderConfigs?marketingEmailId=${marketingEmailId}`);

    return data;
};

export const loadTemplate = async (componentTitle) => {
    const { data } = await axios.post(`${BASE_URL}/template`, componentTitle, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const syncUnlayerEmailLabel = async (cell) => {
    const marketingEmailId = cell.value?.marketingEmailId ?? 0;
    const newName = cell.value?.name ?? '';

    if (marketingEmailId && newName) {
        await axios.put(`${BASE_URL}/template/${marketingEmailId}/title`, JSON.stringify({ title: newName }), {
            headers: {
                'Content-Type': 'Application/json',
            },
        });
    }
};
